/* People's Peps: soft launch landing page (template page.launch).

   - Header links that point at a section on the page (#research, #quality,
     #launch) light up while that section is on screen.
   - The hero form and the full signup form are Shopify's own customer
     (newsletter) form: the email becomes a customer subscribed to email
     marketing, with tags. The script checks the fields first. Nothing is
     sent until they pass, so the consent boxes cannot be skipped. A form
     that passes is posted the normal way through Shopify's spam check
     (hCaptcha, window.Shopify.captcha.protect), and the page comes back with
     the result, shown in a banner at the bottom of the screen.
   - With "Send phone numbers and messages to the store inbox" on, a full
     form that has a phone number or a message first posts a hidden contact
     form (phone, answers and message) into a hidden frame, through the same
     spam check, then posts the signup.
   - The email row above the full form does not sign anyone up on its own: it
     carries the email into the full form and takes the visitor there.
   - Every message comes from the section's settings (data-msg-* attributes).
   - "I'm signing up as" opens as a list inside the form, as in the design.
     The native select stays in the page, hidden, and keeps the value; without
     this script it is shown as it is.

   Customizer-safe: one guard, delegated listeners on document, and the
   header observer is rebuilt on shopify:section:load. */
(function () {
  'use strict';
  if (window.__ppLaunchWired) return;
  window.__ppLaunchWired = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* ---------- result banner ---------- */
  var toast, toastTimer;
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 26 20" fill="none" stroke="#fff" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 10.5l7 7L23.5 2.5"/></svg>';
  function buildToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'pp-ln-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<span class="pp-ln-toast__icon"></span><span class="pp-ln-toast__txt"><span class="pp-ln-toast__h" role="heading" aria-level="2"></span><span class="pp-ln-toast__p" style="display:block"></span></span>';
    toast.addEventListener('click', hideToast);
    document.body.appendChild(toast);
    return toast;
  }
  function hideToast() {
    if (!toast) return;
    toast.classList.remove('is-on');
    clearTimeout(toastTimer);
  }
  function showToast(ok, title, text) {
    var t = buildToast();
    t.classList.toggle('is-ok', !!ok);
    t.querySelector('.pp-ln-toast__icon').innerHTML = ok ? ICON_OK : ICON_X;
    t.querySelector('.pp-ln-toast__h').textContent = title || '';
    var p = t.querySelector('.pp-ln-toast__p');
    p.textContent = text || '';
    p.style.display = text ? 'block' : 'none';
    t.setAttribute('role', ok ? 'status' : 'alert');
    /* restart the slide so a second message in a row is noticed */
    t.classList.remove('is-on');
    void t.offsetWidth;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, ok ? 9000 : 6500);
  }

  /* each form carries its words and tags on a hidden [data-pp-ln-msgs] element */
  function cfg(form) { return (form && form.querySelector('[data-pp-ln-msgs]')) || form; }
  function msg(form, key) { var c = cfg(form); return (c && c.getAttribute('data-msg-' + key)) || ''; }
  function fail(form, key, field) {
    showToast(false, msg(form, 'err-title'), msg(form, key));
    if (field && field._ppDd) field = field._ppDd;
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      try { field.focus({ preventScroll: false }); } catch (e) { field.focus(); }
    }
    return false;
  }
  function clearInvalid(form) {
    Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid="true"]'), function (el) { el.removeAttribute('aria-invalid'); });
  }

  /* ---------- tags ---------- */
  function splitTags(s) {
    return String(s || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  }
  function buildTags(form) {
    var out = [], seen = {};
    var add = function (t) { if (t && !seen[t.toLowerCase()]) { seen[t.toLowerCase()] = 1; out.push(t); } };
    splitTags(cfg(form).getAttribute('data-tags')).forEach(add);
    var role = form.querySelector('[data-pp-ln-role]');
    if (role && role.value) {
      var opt = role.options[role.selectedIndex];
      add(opt && opt.getAttribute('data-tag'));
    }
    Array.prototype.forEach.call(form.querySelectorAll('[data-pp-ln-interest]:checked'), function (c) { add(c.getAttribute('data-tag')); });
    return out;
  }

  /* ---------- a copy for the team inbox (full form only) ---------- */
  function labelText(form, sel) {
    var el = form.querySelector(sel);
    return el ? el.textContent.replace(/\s+/g, ' ').replace(/\*/g, '').trim() : '';
  }
  function inboxLines(form, email) {
    var c = cfg(form);
    var lines = [c.getAttribute('data-inbox-title') || ''];
    var phone = form.querySelector('[data-pp-ln-phone]');
    var role = form.querySelector('[data-pp-ln-role]');
    var note = form.querySelector('[data-pp-ln-note]');
    var picks = Array.prototype.map.call(form.querySelectorAll('[data-pp-ln-interest]:checked'), function (c) {
      var l = c.closest('label');
      return l ? l.textContent.replace(/\s+/g, ' ').trim() : c.value;
    });
    lines.push(labelText(form, '[data-pp-ln-l="email"]') + ': ' + email);
    if (phone && phone.value.trim()) lines.push(labelText(form, '[data-pp-ln-l="phone"]') + ': ' + phone.value.trim());
    if (role && role.value) lines.push(labelText(form, '[data-pp-ln-l="role"]') + ': ' + role.options[role.selectedIndex].text);
    if (picks.length) lines.push(labelText(form, '[data-pp-ln-l="interest"]') + ': ' + picks.join(', '));
    if (note && note.value.trim()) lines.push('', note.value.trim());
    Array.prototype.forEach.call(form.querySelectorAll('[data-pp-ln-require]'), function (c) {
      var l = c.closest('label');
      if (c.checked && l) lines.push('[x] ' + l.textContent.replace(/\s+/g, ' ').trim());
    });
    lines.push('', location.origin + location.pathname);
    return lines.join('\n');
  }

  /* Shopify's own post, through its spam check when the shop has it on */
  function captchaSubmit(form) {
    var cap = window.Shopify && window.Shopify.captcha;
    if (cap && typeof cap.protect === 'function') {
      try { cap.protect(form, function () { form.submit(); }); return; } catch (e) { /* plain post below */ }
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  /* the copy for the store inbox goes into a hidden frame, so the page stays */
  function sendInboxCopy(form, email, next) {
    var box = cfg(form).getAttribute('data-inbox') === 'true' && form.id && document.querySelector('form[data-pp-ln-inbox="' + form.id + '"]');
    var phone = form.querySelector('[data-pp-ln-phone]');
    var note = form.querySelector('[data-pp-ln-note]');
    /* only needed when there is something the signup's tags cannot hold */
    if (!box || !((phone && phone.value.trim()) || (note && note.value.trim()))) { next(); return; }
    var set = function (n, v) { var el = box.elements[n]; if (el) el.value = v; };
    set('contact[email]', email);
    set('contact[phone]', phone ? phone.value.trim() : '');
    set('contact[body]', inboxLines(form, email));
    var name = box.getAttribute('target') || 'pp-ln-inbox-frame';
    var old = document.querySelector('iframe[name="' + name + '"]');
    if (old) old.parentNode.removeChild(old);
    var frame = document.createElement('iframe');
    frame.name = name;
    frame.title = '';
    frame.tabIndex = -1;
    frame.setAttribute('aria-hidden', 'true');
    frame.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0;visibility:hidden;';
    document.body.appendChild(frame);
    var t0 = Date.now(), over = false, poll;
    var finish = function () {
      if (over) return;
      over = true;
      clearInterval(poll);
      setTimeout(function () { if (frame.parentNode) frame.parentNode.removeChild(frame); }, 60);
      next();
    };
    /* once the frame moves on from the post (to the page or to /challenge) the message has been handled */
    poll = setInterval(function () {
      var href = '';
      try { href = frame.contentWindow.location.href; } catch (e) { href = ''; }
      if ((href && href !== 'about:blank') || Date.now() - t0 > 20000) finish();
    }, 150);
    captchaSubmit(box);
  }

  /* ---------- the two signup forms ---------- */
  function validate(form) {
    clearInvalid(form);
    var email = form.querySelector('input[type="email"]');
    if (!email || !EMAIL_RE.test(email.value.trim())) return fail(form, 'email', email);
    var role = form.querySelector('[data-pp-ln-role]');
    if (role && !role.value) return fail(form, 'role', role);
    var reqs = form.querySelectorAll('[data-pp-ln-require]');
    for (var i = 0; i < reqs.length; i++) {
      if (!reqs[i].checked) return fail(form, reqs[i].getAttribute('data-pp-ln-require'), reqs[i]);
    }
    return true;
  }

  function submitSignup(form) {
    if (form.getAttribute('aria-busy') === 'true') return;
    var email = form.querySelector('input[type="email"]');
    var tagsIn = form.querySelector('input[name="contact[tags]"]');
    if (tagsIn) tagsIn.value = buildTags(form).join(', ');
    email.value = email.value.trim();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    form.setAttribute('aria-busy', 'true');
    /* the page normally moves on; if it has not after a while (a spam check left open), let the visitor try again */
    setTimeout(function () { if (btn) btn.disabled = false; form.removeAttribute('aria-busy'); }, 12000);
    sendInboxCopy(form, email.value, function () { captchaSubmit(form); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute) return;

    /* the email row that hands over to the full form */
    if (form.hasAttribute('data-pp-ln-handoff')) {
      e.preventDefault();
      clearInvalid(form);
      var hin = form.querySelector('input[type="email"]');
      if (!hin || !EMAIL_RE.test(hin.value.trim())) { fail(form, 'email', hin); return; }
      var target = document.getElementById(form.getAttribute('data-target') || '');
      if (!target) return;
      var tin = target.querySelector('input[type="email"]');
      if (tin) tin.value = hin.value.trim();
      var next = target.querySelector('[data-pp-ln-role]') || tin;
      if (next && next._ppDd) next = next._ppDd;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (next) setTimeout(function () { try { next.focus({ preventScroll: true }); } catch (x) { next.focus(); } }, reduce ? 0 : 450);
      return;
    }

    if (!form.hasAttribute('data-pp-ln-form')) return;
    /* this listener runs first (capture on document); stopping the event here keeps
       Shopify's own submit handlers from posting a form that has not passed */
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!validate(form)) return;
    submitSignup(form);
  }, true);

  /* clear the red outline as soon as the field is fixed */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (el && el.getAttribute && el.getAttribute('aria-invalid') === 'true') el.removeAttribute('aria-invalid');
  });
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.classList) return;
    if (el.getAttribute('aria-invalid') === 'true') el.removeAttribute('aria-invalid');
    if (el.tagName === 'SELECT' && el.classList.contains('pp-ln-select')) syncSelect(el);
  });
  function syncSelect(sel) { sel.classList.toggle('is-empty', !sel.value); ddRender(sel); }

  /* ---------- "I'm signing up as": a list that opens in place ---------- */
  /* Select-only combobox (WAI-ARIA pattern): the button keeps focus, arrows
     move through the options, Enter, Space or a click picks one, Escape
     closes, Tab picks the highlighted one and moves on. */
  function ddItems(btn) { return Array.prototype.slice.call(btn._ppList.children); }
  function ddIsOpen(btn) { return btn.getAttribute('aria-expanded') === 'true'; }
  function ddRender(sel) {
    var btn = sel && sel._ppDd;
    if (!btn) return;
    var opt = sel.options[sel.selectedIndex];
    btn.querySelector('.pp-ln-dd__val').textContent = opt ? opt.text : '';
    btn.classList.toggle('is-empty', !sel.value);
    ddItems(btn).forEach(function (li) {
      li.setAttribute('aria-selected', String(!!sel.value && +li.getAttribute('data-index') === sel.selectedIndex));
    });
  }
  function ddSelectedPos(btn) {
    var sel = btn._ppSel, items = ddItems(btn);
    if (!sel.value) return -1;
    for (var i = 0; i < items.length; i++) if (+items[i].getAttribute('data-index') === sel.selectedIndex) return i;
    return -1;
  }
  function ddSetActive(btn, n) {
    var items = ddItems(btn);
    if (!items.length) return;
    n = Math.max(0, Math.min(items.length - 1, n));
    btn._ppActive = n;
    items.forEach(function (li, i) { li.classList.toggle('is-active', i === n); });
    btn.setAttribute('aria-activedescendant', items[n].id);
  }
  function ddOpen(btn, n) {
    if (!ddIsOpen(btn)) {
      btn._ppList.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      btn._ppWrap.classList.add('is-open');
    }
    var cur = ddSelectedPos(btn);
    ddSetActive(btn, n == null ? (cur < 0 ? 0 : cur) : n);
    if (document.activeElement !== btn) { try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); } }
  }
  function ddClose(btn) {
    btn._ppList.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    btn.removeAttribute('aria-activedescendant');
    btn._ppWrap.classList.remove('is-open');
    ddItems(btn).forEach(function (li) { li.classList.remove('is-active'); });
  }
  function ddPick(btn, n) {
    var li = ddItems(btn)[n];
    if (!li) return;
    var sel = btn._ppSel;
    sel.selectedIndex = +li.getAttribute('data-index');
    btn.removeAttribute('aria-invalid');
    var ev;
    try { ev = new Event('change', { bubbles: true }); } catch (e) { ev = document.createEvent('Event'); ev.initEvent('change', true, false); }
    sel.dispatchEvent(ev);
  }
  function ddMatch(btn, ch) {
    var items = ddItems(btn), n = items.length;
    var start = ddIsOpen(btn) ? btn._ppActive : ddSelectedPos(btn);
    ch = ch.toLowerCase();
    for (var i = 1; i <= n; i++) {
      var j = ((start < 0 ? -1 : start) + i) % n;
      if (items[j].textContent.trim().toLowerCase().indexOf(ch) === 0) return j;
    }
    return -1;
  }
  function ddKey(e) {
    var btn = e.currentTarget, k = e.key, last = ddItems(btn).length - 1;
    var typed = k && k.length === 1 && k !== ' ' && !e.ctrlKey && !e.metaKey && !e.altKey;
    if (!ddIsOpen(btn)) {
      if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Enter' || k === ' ') { e.preventDefault(); ddOpen(btn); }
      else if (k === 'Home') { e.preventDefault(); ddOpen(btn, 0); }
      else if (k === 'End') { e.preventDefault(); ddOpen(btn, last); }
      else if (typed) { var m = ddMatch(btn, k); if (m > -1) { e.preventDefault(); ddOpen(btn, m); } }
      return;
    }
    switch (k) {
      case 'ArrowDown': e.preventDefault(); ddSetActive(btn, btn._ppActive + 1); break;
      case 'ArrowUp':
        e.preventDefault();
        if (e.altKey) { ddPick(btn, btn._ppActive); ddClose(btn); } else ddSetActive(btn, btn._ppActive - 1);
        break;
      case 'Home': case 'PageUp': e.preventDefault(); ddSetActive(btn, 0); break;
      case 'End': case 'PageDown': e.preventDefault(); ddSetActive(btn, last); break;
      case 'Enter': case ' ': e.preventDefault(); ddPick(btn, btn._ppActive); ddClose(btn); break;
      case 'Escape': e.preventDefault(); ddClose(btn); break;
      case 'Tab': ddPick(btn, btn._ppActive); ddClose(btn); break;
      default:
        if (typed) { var mm = ddMatch(btn, k); if (mm > -1) { e.preventDefault(); ddSetActive(btn, mm); } }
    }
  }
  function enhanceSelect(sel) {
    if (sel._ppDd || !sel.id) return;
    var wrap = sel.parentNode;
    if (!wrap || !wrap.classList || !wrap.classList.contains('pp-ln-selectw')) return;
    var label = document.querySelector('label[for="' + sel.id + '"]');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = sel.id + '-dd';
    btn.className = 'pp-ln-select pp-ln-dd__btn';
    btn.setAttribute('role', 'combobox');
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', sel.id + '-list');
    if (sel.required) btn.setAttribute('aria-required', 'true');
    var val = document.createElement('span');
    val.className = 'pp-ln-dd__val';
    btn.appendChild(val);
    var list = document.createElement('ul');
    list.id = sel.id + '-list';
    list.className = 'pp-ln-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    if (label) {
      if (!label.id) label.id = sel.id + '-label';
      btn.setAttribute('aria-labelledby', label.id);
      list.setAttribute('aria-labelledby', label.id);
      label.setAttribute('for', btn.id);
      /* like a native select: the label focuses the field, it does not open it */
      label.addEventListener('click', function (e) { e.preventDefault(); btn.focus(); });
    }
    var n = 0;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].disabled) continue;
      var li = document.createElement('li');
      li.id = sel.id + '-opt' + (n++);
      li.className = 'pp-ln-dd__opt';
      li.setAttribute('role', 'option');
      li.setAttribute('data-index', String(i));
      li.textContent = sel.options[i].text;
      list.appendChild(li);
    }
    sel.hidden = true;
    sel.tabIndex = -1;
    wrap.insertBefore(btn, sel);
    wrap.appendChild(list);
    sel._ppDd = btn;
    btn._ppSel = sel;
    btn._ppList = list;
    btn._ppWrap = wrap;
    btn.addEventListener('keydown', ddKey);
    /* Space would also "click" the button when released; the keydown above already handled it */
    btn.addEventListener('keyup', function (e) { if (e.key === ' ') e.preventDefault(); });
    btn.addEventListener('click', function () {
      if (ddIsOpen(btn)) ddClose(btn); else ddOpen(btn);
    });
    btn.addEventListener('blur', function () { if (ddIsOpen(btn)) ddClose(btn); });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('mousemove', function (e) {
      var o = e.target.closest ? e.target.closest('.pp-ln-dd__opt') : null;
      if (!o) return;
      var at = ddItems(btn).indexOf(o);
      if (at !== btn._ppActive) ddSetActive(btn, at);
    });
    list.addEventListener('click', function (e) {
      var o = e.target.closest ? e.target.closest('.pp-ln-dd__opt') : null;
      if (!o) return;
      ddPick(btn, ddItems(btn).indexOf(o));
      ddClose(btn);
      try { btn.focus({ preventScroll: true }); } catch (x) { btn.focus(); }
    });
    ddRender(sel);
  }
  function enhanceAll() {
    Array.prototype.forEach.call(document.querySelectorAll('select[data-pp-ln-role]'), enhanceSelect);
  }
  /* a click anywhere else closes an open list (Safari does not focus buttons on click, so blur alone is not enough) */
  document.addEventListener('click', function (e) {
    Array.prototype.forEach.call(document.querySelectorAll('.pp-ln-selectw.is-open'), function (w) {
      if (w.contains(e.target)) return;
      var b = w.querySelector('.pp-ln-dd__btn');
      if (b) ddClose(b);
    });
  }, true);

  /* ---------- header: light up the link for the section on screen ---------- */
  var io;
  function wireNav() {
    if (io) { io.disconnect(); io = null; }
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-pp-ln-nav] a[href^="#"]'));
    if (!links.length || !('IntersectionObserver' in window)) return;
    var map = [];
    links.forEach(function (a) {
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      var sec = id && document.getElementById(id);
      if (sec) map.push({ a: a, sec: sec, seen: 0 });
    });
    if (!map.length) return;
    var setActive = function (item) {
      map.forEach(function (m) {
        var on = m === item;
        m.a.classList.toggle('is-active', on);
        if (on) m.a.setAttribute('aria-current', 'true'); else m.a.removeAttribute('aria-current');
      });
    };
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        map.forEach(function (m) { if (m.sec === en.target) m.seen = en.isIntersecting ? en.intersectionRatio : 0; });
      });
      var best = null;
      map.forEach(function (m) { if (m.seen > 0 && (!best || m.seen > best.seen)) best = m; });
      if (best) setActive(best);
    }, { rootMargin: '-20% 0px -45% 0px', threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
    map.forEach(function (m) { io.observe(m.sec); });
  }

  function settleTo(el) {
    var go = function () { try { el.scrollIntoView({ block: 'start' }); } catch (e) { el.scrollIntoView(); } };
    if (document.readyState === 'complete') setTimeout(go, 150);
    else window.addEventListener('load', function () { setTimeout(go, 150); }, { once: true });
  }

  function start() {
    wireNav();
    enhanceAll();
    Array.prototype.forEach.call(document.querySelectorAll('select.pp-ln-select'), syncSelect);
    Array.prototype.forEach.call(document.querySelectorAll('form[data-pp-ln-form], form[data-pp-ln-handoff]'), function (f) { f.noValidate = true; });
    /* after a post Shopify brings the visitor back here, at the form that was sent (#its-id) */
    var hashForm = null;
    try { hashForm = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null; } catch (e) { hashForm = null; }
    if (hashForm && !(hashForm.matches && hashForm.matches('form[data-pp-ln-form]'))) hashForm = null;
    var pick = function (sel) {
      if (hashForm) return hashForm.querySelector(sel);
      return document.querySelector('form[data-pp-ln-form] ' + sel);
    };
    var flag = pick('[data-pp-ln-msgs][data-posted="true"]');
    var bad = pick('[data-pp-ln-err]');
    if (flag) {
      var posted = flag.closest('form');
      showToast(true, msg(posted, 'ok-title'), msg(posted, 'ok-text'));
    } else if (bad) {
      var f = bad.closest('form');
      showToast(false, msg(f, 'err-title'), bad.textContent.replace(/\s+/g, ' ').trim() || msg(f, 'fail'));
    }
    /* Shopify brings the visitor back to the form's #id, but the browser jumps there
       before the shop's sticky bar and header have been measured, so the form ends up
       under them. Settle on the section once the page has loaded. */
    var landed = flag ? flag.closest('form') : (bad ? bad.closest('form') : null);
    if (landed && landed === hashForm) settleTo(landed.closest('.pp-ln-anchor') || landed);
    /* drop Shopify's ?customer_posted=true so a refresh does not show the banner again */
    if (flag && window.history && history.replaceState && /customer_posted=/.test(location.search)) {
      var q = location.search.replace(/([?&])customer_posted=[^&]*&?/, '$1').replace(/[?&]$/, '');
      try { history.replaceState(history.state, '', location.pathname + q + location.hash); } catch (e) { /* keep the address as it is */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('form[data-pp-ln-form], form[data-pp-ln-handoff]'), function (f) { f.noValidate = true; });
    wireNav();
    enhanceAll();
    Array.prototype.forEach.call(document.querySelectorAll('select.pp-ln-select'), syncSelect);
  });
})();
